<!-- ErrorBoundary.vue -->
<template>
  <slot></slot>
</template>

<script setup lang="ts">
import { onErrorCaptured } from 'vue'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'

import * as Sentry from '@sentry/vue'

const { t } = useI18n()

onErrorCaptured((err: Error, instance, info: string) => {
  console.error('[ErrorBoundary] Captured error:', err)
  console.error('[ErrorBoundary] Component:', instance)
  console.error('[ErrorBoundary] Info:', info)

  Sentry.captureException(err, {
    extra: { info, componentName: instance?.$options?.name },
  })

  toast.error(t('generic.errorBoundaryTitle'), {
    description: t('generic.errorBoundaryDescription'),
    duration: Infinity,
    dismissible: true,
    closeButton: true,
    action: {
      label: t('generic.errorReloadPage'),
      onClick: () => window.location.reload(),
    },
  })

  return false
})
</script>
